import styles from "./BackButton.module.scss";
import {ARTIST, Artist} from "../utils/artist.utils";

type BackButtonProps = {
  artist: Artist;
  onClick: () => void;
};

const BackButton = ({artist, onClick}: BackButtonProps) => {
  let backButtonStyle: {color: string; boxShadow: string} = {
    color: "#a749c8",
    boxShadow: "0 2px 0 0 #a749c8",
  };
  if (artist === ARTIST.riize) {
    backButtonStyle = {
      color: "#ffa503",
      boxShadow: "0 2px 0 0 #ffa503",
    };
  }

  return (
    <button
      type="button"
      className={styles.button}
      onClick={onClick}
      style={backButtonStyle}
    >
      <svg
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={styles.icon}
      >
        <path
          d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z"
          fill="white"
        />
        <path
          d="M17.4013 19.2207L20.862 22.7754C21.0032 22.9205 21.0709 23.0898 21.065 23.2833C21.0591 23.4767 20.9856 23.646 20.8443 23.7911C20.7031 23.9241 20.5383 23.9936 20.3499 23.9996C20.1616 24.0057 19.9968 23.9362 19.8555 23.7911L15.1942 19.0031C15.1236 18.9306 15.0736 18.852 15.0441 18.7673C15.0147 18.6827 15 18.592 15 18.4953C15 18.3986 15.0147 18.3079 15.0441 18.2232C15.0736 18.1386 15.1236 18.06 15.1942 17.9875L19.8555 13.1995C19.985 13.0665 20.1469 13 20.3411 13C20.5353 13 20.7031 13.0665 20.8443 13.1995C20.9856 13.3446 21.0562 13.5169 21.0562 13.7164C21.0562 13.9159 20.9856 14.0882 20.8443 14.2333L17.4013 17.7698H25.2937C25.4938 17.7698 25.6616 17.8394 25.797 17.9784C25.9323 18.1174 26 18.2897 26 18.4953C26 18.7008 25.9323 18.8731 25.797 19.0122C25.6616 19.1512 25.4938 19.2207 25.2937 19.2207H17.4013Z"
          fill="currentColor"
        />
      </svg>
    </button>
  );
};

export default BackButton;
